// @ts-strict-ignore
import 'common/types/globals/window';
import {DownloadMode} from 'common/report/constants';
import {purgeFetchCache} from 'common/report/queries/utils/fetch-cache';
import {getDownloadMode, getProjectId, getReportName, isAuthMode, isPublicMode, isVolt} from 'common/report/util';
import {logPanelSlowRenders, trackReportLoadPerf} from 'common/report/perf-measure';
import {parseStateFromUrl} from 'common/report/util/state-from-url';
import {logTopLevelError, reporter} from 'common/report/error-reporting';
import {SessionHeartbeatSingleton} from 'common/report/util/session-heartbeat';
import {
  mpSdkInitTrackingProps,
  registerUnpersisted,
  setReferrerSuperpropsAndBaseTracking,
} from 'common/report/report-tracker';
import {apiClient} from 'common/util/api-client';
import {trackVisitedReport, VisitedReportReason} from 'common/util/server-tracking';
import {userCookieUtils} from 'common/report/util/user-identity-from-cookie';
// TODO: move this logic somewhere in react app
import 'common/widgets/nps-survey'; // important here.. the nps-survey is still a web component

async function initNpsSurvey(projectId) {
  function showNpsSurvey() {
    const npsSurvey = document.createElement(`nps-survey`);
    npsSurvey.addEventListener(`closed`, () => document.body.removeChild(npsSurvey));
    document.body.appendChild(npsSurvey);
  }

  if (getDownloadMode() === DownloadMode.None && !isPublicMode() && !isAuthMode()) {
    // for local-dev testing
    if (localStorage.getItem(`mp_show_nps_survey`)) {
      showNpsSurvey();
    } else {
      const response = await apiClient.get<{show_survey: boolean}>(`/api/app/nps_survey/show_survey`, {
        project_id: projectId,
      });
      if (response.show_survey) {
        showNpsSurvey();
      }
    }
  }
}

function trackVoltReportLoad() {
  const bundler = process.env.BUNDLER || `webpack`;

  const urlState = parseStateFromUrl();
  const projectId = urlState.projectId;
  const tab = getReportName(urlState.appName);
  setReferrerSuperpropsAndBaseTracking({userId: userCookieUtils.getUserIdentityFromCookie()?.id});
  registerUnpersisted(mixpanel, {project_id: projectId});
  mixpanel.track(`Viewed report`, {tab, is_volt: true, bundler});
  trackVisitedReport({projectId, reportName: tab, reason: VisitedReportReason.ReportVoltLoad});
  trackReportLoadPerf(projectId, tab, {is_volt: isVolt});
}

/**
 * In the event Panel encounters an exception rendering a components template, a `renderError` is dispatched
 * as a custom event. The event contains original error and the component where it occurred.
 */
function logPanelRenderErrors() {
  window.addEventListener(`renderError`, (ev: CustomEvent<{component: HTMLElement; error: Error}>) => {
    const {component, error} = ev.detail;
    reporter.error(error, `Error while rendering ${component.tagName.toLowerCase()}`);
  });
}
function logErrors() {
  window.addEventListener(`error`, logTopLevelError);
}

async function addUserIdentityToSentryIfGdprAllowsTracking() {
  // if you want to restore this, plumb window.Sentry.setUser into this view
}

function handleWindowLoad() {
  window.removeEventListener(`load`, handleWindowLoad);
  const projectId = getProjectId();

  initNpsSurvey(projectId);
  purgeFetchCache(); // delete cached entries in fetch-cache over ttl
}

/// --- main  --- ///

window.addEventListener(`load`, handleWindowLoad);
logPanelRenderErrors();
addUserIdentityToSentryIfGdprAllowsTracking();

// init tracking for volt reports
if (isVolt()) {
  trackVoltReportLoad();
}

if (isPublicMode() || isAuthMode()) {
  // @ts-ignore
  mixpanel.start_batch_senders();
} else {
  logPanelSlowRenders();
  logErrors();
  mpSdkInitTrackingProps();
  SessionHeartbeatSingleton.start();
}
